export const AdminUrl = {
  Home: () => "/admin/partners",
  CampaignView: (campaignId: number) => `/admin/campaign/${campaignId}/view`,
  BrandView: (brandId: number) => `/admin/brand/${brandId}/view`,
  PartnerView: (partnerId: number) => `/admin/partner/${partnerId}/view`,
  AdIncidentsView: () => `/admin/ad-incidents`,
  PublicationIncidentsView: () => `/admin/publication-incidents`,
};
